import axios from 'axios';

export const http = axios.create({
  baseURL: process.env.API_HOST
});

export const httpBasic = axios.create();

export const prepareHttpQuery = query => {
  const queryString = Object.keys(query)
    .filter(key => query[key] !== undefined && query[key] !== null && query[key] !== '')
    .map(key => `${encodeURIComponent(key)}=${query[key]}`)
    .join('&');

  return queryString ? `?${queryString}` : '';
};

export const downloadFile = async fileURL => {
  try {
    const response = await httpBasic.get(fileURL, {
      responseType: 'blob' // Importante para manejar el blob
    });

    // Crear un URL temporal a partir del blob
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const fileExtension = response.headers['content-type'].split('/')[1];

    // Crear un enlace temporal de descarga
    const link = document.createElement('a');
    link.href = url;
    link.download = `Acta.${fileExtension}`;
    document.body.appendChild(link);
    link.click();

    // Cerrar el objeto URL y el enlace
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error al descargar el archivo:', error);
  }
};
